/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoiceSummary } from '../../axios/invoiceSummary'
import type { InvoiceSummaryError, InvoiceSummaryPathParams, InvoiceSummaryResponse } from '../../types/InvoiceSummary'

export const invoiceSummaryQueryKey = (organisation: InvoiceSummaryPathParams['organisation']) =>
	[{ url: '/:organisation/invoices/summary', params: { organisation } }] as const

export type InvoiceSummaryQueryKey = ReturnType<typeof invoiceSummaryQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::summary */
export function invoiceSummaryQueryOptions(
	organisation: InvoiceSummaryPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		InvoiceSummaryResponse,
		AxiosError<InvoiceSummaryError>,
		InvoiceSummaryResponse,
		InvoiceSummaryQueryKey
	>({
		queryKey: invoiceSummaryQueryKey(organisation),
		queryFn: ({ signal }) => invoiceSummary(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::summary */
export function useInvoiceSummary<TSelectData = InvoiceSummaryResponse>(
	organisation: InvoiceSummaryPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					InvoiceSummaryResponse,
					AxiosError<InvoiceSummaryError>,
					TSelectData,
					InvoiceSummaryQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<InvoiceSummaryError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...invoiceSummaryQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::summary */
export function useInvoiceSummarySuspense<TSelectData = InvoiceSummaryResponse>(
	organisation: InvoiceSummaryPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					InvoiceSummaryResponse,
					AxiosError<InvoiceSummaryError>,
					TSelectData,
					InvoiceSummaryQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<InvoiceSummaryError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...invoiceSummaryQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
